import React from "react";
import Select from "@components/select";
import { EMPLOYMENT_OPTIONS } from "../../../../constants/options";
import { useFormikContext } from "formik";
import { usePendingPrefill, useSetDefaultValue } from "@hooks";

const name = "employmentBasis";

export default function Employment() {
  const { handleChange, handleBlur, values, errors, touched } = useFormikContext();
  useSetDefaultValue(name);
  usePendingPrefill(name);
  
  return (
    <>
      <Select
        isPlaceHolder
        placeholder="Select..."
        title="Employment Type"
        options={EMPLOYMENT_OPTIONS}
        toolTipText="I receive the majority of my income from"
        
        name={name}
        value={values[name]}
        onChange={handleChange}
        onBlur={handleBlur}
        errorMessage={touched[name] ? errors[name] : ""}
      />
    </>
  );
}
